import { DatePicker, Form } from 'antd';

const CustomDateInput = ({ form, onChange = () => {}, label, name, size = 'default', rules, value, placeholder, disabledDate, disabled, style }) => {
	return (
		<Form.Item label={label} name={name} rules={rules}>
			{/* {disabled ? (
				<CustomInputLabel label={form?.getFieldValue(name) ?? (value ? value : '')} />
			) : ( */}
			<DatePicker
				size={size}
				onChange={onChange}
				disabled={disabled}
				placeholder={placeholder}
				style={{ width: '100%' }}
				disabledDate={disabledDate}
			/>
			{/* )} */}
		</Form.Item>
	);
};

export default CustomDateInput;
